import { Attribute, Relationship, Resource } from 'json-api';
import { Translatable } from 'src/app/translation/translatable';
import { AtomResource } from '../classes/atom-resource';
import { Product } from './product.resource';

@Resource({
  type: 'thematics',
})
export class Thematic extends AtomResource {
  @Attribute() name?: Translatable;
  @Attribute() desc?: string;

  @Relationship() products?: Product[];
}
